import { useTranslation } from 'react-i18next'
import { useOnboardingPreflight, useOnboardingRun } from '../../../api/hooks'
import type { OnboardingRunScope } from '../../../api/onboardingTypes'
import BulkRunPanel from './BulkRunPanel'

export default function ScopedBulkRun({ scope }: { scope: OnboardingRunScope }) {
  const { t } = useTranslation('pages')
  const run = useOnboardingRun(scope.run_id, scope.target_ids)
  const preflight = useOnboardingPreflight(scope.run_id, scope.target_ids)
  if (run.error) return <p role="alert" className="text-destructive">{t('adminOnboarding.history.loadError')}</p>
  if (!run.data) return <p className="text-muted-foreground">{t('adminOnboarding.history.loading')}</p>
  return <section className="mt-4" data-testid={`onboarding-scope-${scope.run_id}`}>
    <p className="text-sm text-muted-foreground">{t('adminOnboarding.history.scope', { runId: scope.run_id, count: scope.target_ids.length })}</p>
    <BulkRunPanel run={run.data} preflight={preflight.data} targetIds={scope.target_ids} />
  </section>
}
